module.exports = __webpack_public_path__ + "assets/img/Medcafe_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Medcafe_logo.png
// module id = 1915
// module chunks = 0